<template>
  <v-container id="document-container">
    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>

    <v-row>
      <v-col lg="12" md="12" sm="12" class="pt-0">
        <v-btn
          tile
          dark
          class="mt-5 mb-2 primary-color float-right"
          @click.stop="dialog = true"
          v-if="$store.state.role == 'ao'"
        >
          <v-icon size="20" class="">mdi-plus</v-icon>
          Create new folder
        </v-btn>
      </v-col>
      <v-col lg="12" md="12" sm="12" class="pt-0">
        <Title title="Document"></Title>
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          max-width="30%"
        >
          <v-card>
            <v-card-title class="headline"> New folder </v-card-title>

            <v-card-text>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="folderName"
                        :rules="nameRules"
                        label="Folder name"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="primary darken-1" text @click="dialog = false">
                Close
              </v-btn>

              <v-btn color="primary darken-1" text @click="onCreateFolder()">
                Add folder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-list>
          <v-list-group
            v-for="item in folders"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        size="large"
                        v-bind="attrs"
                        v-on="on"
                        v-if="$store.state.role == 'ao'"
                        >mdi-dots-vertical</v-icon
                      >
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(option, index) in parentFolderOptions"
                        :key="index"
                        @click="
                          onSelectOption(option.action, item._id, item.title);
                          folderId = item._id;
                        "
                      >
                        <v-list-item-title>{{
                          option.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="child in item.items" :key="child.title">
              <v-list-item-content>
                <v-list-item-title
                  >{{ child.title }}
                  <a
                    class="float-right ml-2"
                    @click="onRemoveDocument(item._id, child._id)"
                    v-if="$store.state.role == 'ao'"
                    ><v-icon size="20">mdi-close</v-icon></a
                  >
                  <a class="float-right" @click="onDownloadDocument(child.path)"
                    ><v-icon size="20">mdi-download</v-icon></a
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="item.folders" style="padding-left: 58px">
              <v-list-item-content>
                <v-list-item-title>
                  <v-list>
                    <v-list-group
                      v-for="innerItem in item.folders"
                      :key="innerItem._id"
                      v-model="innerItem.active"
                      :prepend-icon="item.action"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ innerItem.name }}
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon size="large" v-bind="attrs" v-on="on"
                                  >mdi-dots-vertical</v-icon
                                >
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(
                                    option, index
                                  ) in formattedInnerFolderOptions"
                                  :key="index"
                                  @click="
                                    onSelectOption(
                                      option.action,
                                      innerItem._id,
                                      innerItem.name
                                    );
                                    folderId = innerItem._id;
                                  "
                                >
                                  <v-list-item-title>{{
                                    option.title
                                  }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <v-list-item
                        v-for="innerChild in innerItem.documents"
                        :key="innerChild.title"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ innerChild.name }}
                            <a
                              class="float-right ml-2"
                              @click="
                                onRemoveDocument(innerItem._id, innerChild._id)
                              "
                              v-if="$store.state.role == 'ao'"
                              ><v-icon size="20">mdi-close</v-icon></a
                            >
                            <a
                              class="float-right"
                              @click="onDownloadDocument(innerChild.path)"
                              ><v-icon size="20">mdi-download</v-icon></a
                            >
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>

        <v-dialog
          v-model="innerFolderDialog"
          transition="dialog-bottom-transition"
          max-width="30%"
        >
          <v-card>
            <v-card-title class="headline"> New folder </v-card-title>

            <v-card-text>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="folderName"
                        :rules="nameRules"
                        label="Folder name"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="innerFolderDialog = false"
              >
                Close
              </v-btn>

              <v-btn
                color="primary darken-1"
                text
                @click="onCreateInnerFolder()"
              >
                Add folder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="renameFolderDialog"
          transition="dialog-bottom-transition"
          max-width="30%"
        >
          <v-card>
            <v-card-title class="headline">Rename folder </v-card-title>
            <v-card-text>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="newFolderName"
                        :rules="nameRules"
                        label="Folder name"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary darken-1"
                text
                @click="renameFolderDialog = false"
              >
                Close
              </v-btn>

              <v-btn color="primary darken-1" text @click="onRenameFolder()">
                Save changes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="documentDialog"
          transition="dialog-bottom-transition"
          max-width="30%"
        >
          <v-card>
            <v-card-title class="headline"> New document </v-card-title>

            <v-card-text>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="documentName"
                        :rules="nameRules"
                        label="Document name"
                        required
                      ></v-text-field>

                      <v-file-input
                        label="Upload document"
                        v-model="uploadedDocument"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary darken-1"
                text
                @click="documentDialog = false"
              >
                Close
              </v-btn>

              <v-btn color="primary darken-1" text @click="onUploadDocument()">
                Add document
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Title from "../components/Title";

export default {
  mounted: async function () {
    await this.getFolders();
  },
  components: {
    Title,
  },
  data: () => ({
    dialog: false,
    innerFolderDialog: false,
    renameFolderDialog: false,
    documentDialog: false,
    nameRules: [(v) => !!v || "Name is required"],
    folderName: "",
    documentName: "",
    uploadedDocument: null,
    folders: [],
    folderId: "",
    snackbar: false,
    snackbarText: "",
    newFolderName: "",
    parentFolderOptions: [
      { title: "Add document to folder", action: "addDocument" },
      { title: "Add folder", action: "addInnerFolder" },
      { title: "Rename folder", action: "renameFolder" },
      { title: "Delete folder", action: "deleteFolder" },
    ],
    innerFolderOptions: [
      { title: "Add document to folder", action: "addDocument" },
      { title: "Download all documents", action: "downloadFolder" },
      { title: "Rename folder", action: "renameFolder" },
      { title: "Delete folder", action: "deleteFolder" },
    ],
  }),
  computed: {
    formattedInnerFolderOptions: function () {
      if (this.$store.state.role == "centre") {
        return [{ title: "Download all documents", action: "downloadFolder" }];
      }

      return this.innerFolderOptions;
    },
  },
  methods: {
    getFolders: async function () {
      const response = await fetch(`${process.env.VUE_APP_ROOT_API}/folders`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      });

      const data = await response.json();

      this.folders = data.folders.map((folder) => {
        const items = folder.documents.map((document) => {
          return {
            _id: document._id,
            title: document.name,
            path: document.path,
          };
        });

        return {
          action: "mdi-folder-outline",
          items,
          title: folder.name,
          _id: folder._id,
          folders: folder.folders,
        };
      });
    },
    onCreateFolder: async function () {
      const response = await fetch(`${process.env.VUE_APP_ROOT_API}/folders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify({ name: this.folderName }),
      });

      const data = await response.json();
      await this.getFolders();

      this.dialog = false;
      this.showSnackbar(data.message);
    },
    onCreateInnerFolder: async function () {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/folders/inner`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({
            parentFolder: this.folderId,
            name: this.folderName,
          }),
        }
      );

      const data = await response.json();
      await this.getFolders();

      this.innerFolderDialog = false;
      this.showSnackbar(data.message);
    },
    showSnackbar: function (message) {
      this.snackbarText = message;
      this.snackbar = true;
    },
    onUploadDocument: async function () {
      const formData = new FormData();
      formData.append("name", this.documentName);
      formData.append("document", this.uploadedDocument);

      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/folders/${this.folderId}/documents`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      this.documentDialog = false;
      this.showSnackbar(data.message);
      await this.getFolders();
    },
    onDownloadDocument: function (filePath) {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/folders/documents/download?file=${filePath}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      )
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = filePath; // the filename you want
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);

          this.snackbarText = "Downloading file ...";
          this.snackbar = true;
        })
        .catch((err) => {
          if (err) {
            this.snackbarText = "File is no longer available";
            this.snackbar = true;
            return;
          }
          console.log(err);
        });
    },
    onDownloadFolder: function (folderId) {
      // console.log(folderId);
      // console.log(this.folders);

      let documents = [];

      for (let i = 0; i < this.folders.length; i++) {
        if (!this.folders[i].folders) continue;

        for (let j = 0; j < this.folders[i].folders.length; j++) {
          const folder = this.folders[i].folders[j];
          if (folder._id == folderId) {
            documents = folder.documents.map((doc) => {
              return doc.path;
            });
          }
        }
      }

      for (let i = 0; i < documents.length; i++) {
        fetch(
          `${process.env.VUE_APP_ROOT_API}/folders/documents/download?file=${documents[i]}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        )
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = documents[i]; // the filename you want
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            this.snackbarText = "Downloading file ...";
            this.snackbar = true;
          })
          .catch((err) => {
            if (err) {
              this.snackbarText = "File is no longer available";
              this.snackbar = true;
              return;
            }
            console.log(err);
          });
      }
    },
    onRemoveDocument: async function (folderId, documentId) {
      const confirm = window.confirm(
        "Are you sure you want to remove this document?"
      );

      if (!confirm) return;

      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/folders/${folderId}/documents?documentId=${documentId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          method: "PATCH",
        }
      );
      const data = await response.json();

      this.showSnackbar(data.message);
      await this.getFolders();
    },
    onSelectOption: async function (action, folderId, folderName) {
      if (action == "addInnerFolder") {
        this.innerFolderDialog = true;
      } else if (action == "addDocument") {
        this.documentDialog = true;
      } else if (action == "renameFolder") {
        this.newFolderName = folderName;
        this.renameFolderDialog = true;
      } else if (action == "deleteFolder") {
        await this.onDeleteFolder(folderId);
      } else if (action == "downloadFolder") {
        await this.onDownloadFolder(folderId);
      }
    },
    onRenameFolder: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/folders/${this.folderId}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
            body: JSON.stringify({ name: this.newFolderName }),
          }
        );

        const data = await response.json();

        this.showSnackbar(data.message);
        await this.getFolders();
        this.renameFolderDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    onDeleteFolder: async function (folderId) {
      try {
        const confirm = window.confirm(
          "Are you sure you want to remove this folder?"
        );

        if (!confirm) return;

        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/folders/${folderId}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.showSnackbar(data.message);
        await this.getFolders();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
#document-container {
  min-height: 100vh;
}

.v-list-item__content {
  padding: 0;
}
</style>